import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=5505f03e&scoped=true"
import script from "./HomeAbout.vue?vue&type=script&lang=ts"
export * from "./HomeAbout.vue?vue&type=script&lang=ts"
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=5505f03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505f03e",
  null
  
)

export default component.exports